import React from 'react';
import { Info } from '@one-thd/sui-icons';

const InfoIcon = () => (
  <Info size="small" />
);

export default InfoIcon;
